import { useEffect } from 'react';

export default function SnapPage({ children }) {
  useEffect(() => {
    document.documentElement.classList.add('snap-mode');
    return () => document.documentElement.classList.remove('snap-mode');
  }, []);
  return <>{children}</>;
}
